import React from "react";
import "./dropdown.css";
export interface DropdownProps {
    onOptionChanged: (id: string) => void;
    options: DropdownOption[];
    label: string;
}

export interface DropdownOption {
    displayName: string;
    id: string;
}

export function Dropdown(props: DropdownProps) {
    return (
        <>
            <label htmlFor="dropdown-id">{props.label} </label>
            <select
                name="compositions"
                id="dropdown-id"
                onChange={(e) => props.onOptionChanged(e.target.value)}
            >
                {props.options.map((opt) => (
                    <>
                        <option value={opt.id}>{opt.displayName}</option>
                    </>
                ))}
            </select>
        </>
    );
}
